module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-active.a07f1ad1.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-active.png
// module id = 3179
// module chunks = 11